import React from "react";

// SAT Kolibri — premium gold-on-midnight mark. Uses the official brand PNG
// from the design schema so it perfectly matches the visual identity.
// The `color` prop is kept for backward-compat (no effect on the image),
// `glow` adds a subtle golden aura behind the bird.
export const Hummingbird = ({ size = 80, className = "", style = {}, glow = true, color }) => {
  // `color` intentionally accepted but unused — image is pre-rendered in SAT Gold.
  void color;
  return (
    <span
      className={`relative inline-block align-middle ${className}`}
      style={{ width: size, height: size, ...style }}
      aria-label="SAT Kolibri"
      role="img"
    >
      {glow && (
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, rgba(212,175,55,0.35) 0%, rgba(212,175,55,0.15) 35%, rgba(212,175,55,0) 65%)",
            filter: "blur(6px)",
          }}
        />
      )}
      <img
        src="/brand/hummingbird-gold.png"
        alt=""
        width={size}
        height={size}
        draggable={false}
        className="relative w-full h-full object-contain select-none"
        style={{ filter: "drop-shadow(0 0 12px rgba(212,175,55,0.25))" }}
      />
    </span>
  );
};

export default Hummingbird;
